<template>
  <div class="right-base-item " @click="showDetail">
    <div class="flex item-center">
      <div class="card-icon">
        <svg-icon :icon-name="iconName" size="24" iconColor="#1e49e2"></svg-icon>
      </div>
      <div class="item-name">{{ itemName }}</div>
    </div>
    <div class="arrow-right-container border-normal">
      <svg-icon icon-name="arrow-right" size="18" iconColor="#1e49e2"></svg-icon>
    </div>
    <ContactSpeedInfo v-if="isShow" :type="type" @close="close" :contactList="contactList" :KPcontactList="KPcontactList"></ContactSpeedInfo>
  </div>
</template>
<script>
import SvgIcon from '@/components/svgIcon/index'
import ContactSpeedInfo from './ContactSpeedInfo.vue'
import API from '@/api';
import {mapGetters} from 'vuex';

export default {
  name: 'RightBaseItem',
  components: { SvgIcon,ContactSpeedInfo },
  props: {
      iconName: { type: String, default: '' },
      itemName:{ type: String, default: '' },
      type:{ type: String, default: 'contact' },
  },
  computed: {
    ...mapGetters('common', {
                getSite: 'getSite',
                getUser: 'getUser'
            }),
  },
  data(){
    return{
      isShow:false,
      contactList: [],
      KPcontactList: [],
    }
  },
  methods:{
    close(){
      this.isShow = false;
    },
    showDetail(){
      this.isShow = true;
    },
    getClientContact() {
      API.common.queryClientContact({siteId: this.getSite.siteId}).then(res => {
          if (res.code == '1' && res.data && res.data.length > 0) {
              /*this.contactList = res.data;*/
              for (let i = 0; i <= res.data.length; i += 3) {
                  this.contactList.push(res.data.slice(i, i + 3))
              }
          }
          if (res.code !== '1') {
              this.$message.error(this.$t(res.code));
          }
      });
      },
      getKPContact() {
          API.common.queryKPContact({siteId: this.getSite.siteId}).then(res => {
              if (res.code == '1' && res.data && res.data.length > 0) {
                  for (let i = 0; i <= res.data.length; i += 3) {
                      this.KPcontactList.push(res.data.slice(i, i + 3))
                  }
              }
              if (res.code !== '1') {
                  this.$message.error(this.$t(res.code));
              }
          });
      }
  },
  mounted(){
    if(this.type === 'contact'){
      this.getClientContact();
      this.getKPContact();
    }  
  }
}
</script>

<style scoped>
.right-base-item{
  display: flex;
  justify-content: space-between;
  background: #f3f6ff;
  margin:10px 0;
  padding: 10px 20px;
  border-radius: 5px;
  align-items: center;
  cursor: pointer;
}
.right-base-item:hover{
  border:1px solid #1e49e2;
}
.card-icon{
  width: 36px;
  height: 36px;
  line-height:36px;
  text-align: center;
  cursor: pointer;
  border:1px solid #e5e5e5;
  flex-shrink: 0;
  background: #ffffff;
  border-radius: 5px;
}

.arrow-right-container{
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.item-name{
  font-size: 16px;
  font-weight: bolder;
  text-align: left;
  margin-left: 20px;
}
</style>

